----- Note :
The class ".terminology-load-licence" of the button is mandatory. It triggers an event located in the following file :
"wp-content/themes/ans/assets/src/scripts/terminology-attachment.js"
This event allows to display a pop-in containing the terminology licence, then to download the document if the licence
is accepted.

<template>
  <div class="terminologies-wrapper terminologies-container">
    <v-btn fab small color="Gray-700" class="pagination-arrow pagination-arrow-top" @click="scrollToTop"
      :disabled="isAtTop">
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>

    <div class="pa-0 terminologies-list-container" ref="scrollContainer" @scroll="handleScroll">
      <v-container v-if="terminologiesStore.state.numberOfTerminologies === 0"
        class="terminology-card-no-data pa-0 my-10">
        <p v-if="search">
          Aucune terminologie ne correspond aux termes de recherche spécifiés : <span class="font-weight-bold">{{ search
          }}</span>.
        </p>
        <p v-else>
          Aucune terminologie ne correspond aux termes de recherche avancée spécifiés.
        </p>
        <p class="mx-0 mt-5 mb-2">Suggestions :</p>
        <ul>
          <li>Vérifiez l'orthographe des termes de recherche.</li>
          <li>Essayer d'autres termes.</li>
          <li>Utilisez des mots clés plus généraux</li>
        </ul>
      </v-container>
      <TerminologieVignette v-else v-for="item in terminologiesStore.state.terminologiesList" :key="item.title"
        :terminology="item" :user="user" />

      <div v-if="hasMoreTerminologies" class="text-center py-4">
        <v-btn fab small color="primary" @click="loadMoreTerminologies" style=" background-color: var(--primary);">
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
      </div>
    </div>

    <v-btn fab small color="Gray-700" class="pagination-arrow pagination-arrow-bottom" @click="scrollToBottom"
      :disabled="isAtBottom">
      <v-icon>mdi-chevron-down</v-icon>
    </v-btn>
  </div>
</template>

<script>
import TerminologiesStore from "../terminologies-store";
import TerminologieVignette from "./TerminologieVignette";
import ScrollNavigationMixin from "../mixins/scroll-navigation.mixin";

export default {
  name: 'Terminologies',

  mixins: [ScrollNavigationMixin],

  components: {
    TerminologieVignette
  },

  props: {
    search: String
  },
  data: () => ({
    terminologiesStore: TerminologiesStore,
    user: undefined,
    currentPageNumber: 1
  })
  ,

  computed: {
    hasMoreTerminologies() {
      return this.terminologiesStore.state.terminologiesList.length < this.terminologiesStore.state.numberOfTerminologies;
    }
  },

  methods: {
    loadMoreTerminologies() {
      this.currentPageNumber += 1;
      let endpoint = '/api/terminologies/search';
      let params = {
        'searchedText': this.search,
        'pagination': this.currentPageNumber,
        'size': TerminologiesStore.state.itemsPerPage,
        'adv': this.terminologiesStore.getExtendedSearch(),

      };

      TerminologiesStore.loadMoreTerminologies(endpoint, params);
    },
  }
}
</script>

<style lang="scss" scoped>
.terminologies-wrapper {
  position: relative;
  height: 90vh;
  width: 100%;
}

.terminologies-list-container {
  height: 100%;
  overflow: auto;
}

.pagination-arrow {
  position: absolute;
  right: 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);

  &.pagination-arrow-top {
    top: 10px;
  }

  &.pagination-arrow-bottom {
    bottom: 10px;
  }

  &:disabled {
    opacity: 0.3;
  }
}

.terminology-card-no-data {
  max-width: 700px !important;
}
</style>